import { ProtectedComponent } from "../components/ProtectedComponent";
import { UserContext } from "../utils/UserContext";
import { useContext, useEffect, useState } from "react";
import FormCard from "../components/FormCard";
import Table from "../components/Table";
import axiosInstance from "../utils/axiosInstance";
import { Button, Spinner, Label } from "flowbite-react";
import ApiKeysModal from "../components/ApiKeysModal";
import { IconContext } from "react-icons";
import useTheme from "../contexts/ThemeContext";
import { PageTitle } from "../components/PageTitle";

export default function Home() {
  const [theme, setTheme] = useState(useTheme());
  const { user } = useContext(UserContext);
  const [brands, setBrands] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [loadingBrands, setLoadingBrands] = useState(false);
  useEffect(() => {
    setLoadingBrands(true);
    axiosInstance
      .get(`/v51/companies/${user.companyId}/brands`)
      .then((res) => {
        setBrands(res.data);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoadingBrands(false);
      });
  }, []);

  return (
    <ProtectedComponent>
      <IconContext.Provider
        value={{
          color: theme == "dark" ? "white" : "black",
          className: "global-class-name",
        }}
      >
        <section className="mx-auto flex w-full flex-col items-center justify-center bg-transparent px-6 py-8 lg:w-9/12 lg:px-2 lg:py-0">
          <PageTitle title="Home" />
          <FormCard>
            <h3 className="text-left align-bottom dark:text-white ">
              Hello{" "}
              <span className="font-bold">
                {user.lastName} {user.firstName}
              </span>
              , you are assigned to{" "}
              <span className="font-bold">{user.company}</span>
            </h3>
          </FormCard>
          <FormCard>
            <Label>Brands registered to your company:</Label>

            {brands?.length == 0 ? (
              <div>
                <Spinner />
              </div>
            ) : (
              <Table columns={getColumns()} data={brands} />
            )}
          </FormCard>
        </section>
        {selectedBrand && (
          <ApiKeysModal
            show={showModal}
            onClose={() => setShowModal(false)}
            brand={selectedBrand}
          />
        )}
      </IconContext.Provider>
    </ProtectedComponent>
  );

  function getColumns() {
    return [
      {
        key: "name",
        name: "Name",
      },
      {
        key: "apikey",
        name: "API Key",
        type: "dynamic",
        content: getApiKey,
      },
    ];
  }

  function getApiKey(brand) {
    return (
      <Button
        onClick={() => {
          setSelectedBrand(brand);
          setShowModal(true);
        }}
        color="blue"
        size="sm"
      >
        Show Keys
      </Button>
    );
  }
}
